import { render, staticRenderFns } from "./ResearcherStats.vue?vue&type=template&id=6e4e83ba&scoped=true&"
import script from "./ResearcherStats.vue?vue&type=script&lang=js&"
export * from "./ResearcherStats.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherStats.vue?vue&type=style&index=0&id=6e4e83ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4e83ba",
  null
  
)

export default component.exports